module.exports = __webpack_public_path__ + "static/media/Sappa_Play_Green.b2e6e58f.png";